import app from './src/app';

import './src/sass/index.sass';

console.log( 'hello world' );

app();


